import styled from "styled-components";

export const Title = styled.h3`
  font-size: 24px;
  font-weight: 600;
  width: 100%;
  text-align: center;
  margin: 32px 0 32px 0;
`;
